module.exports = __webpack_public_path__ + "img/photo.985777a8.svg";